'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LogTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _LogEntry = require('./LogEntry.js');

var _LogLevel = require('./LogLevel.js');

var _reactTime = require('react-time');

var _reactTime2 = _interopRequireDefault(_reactTime);

var _reactResponsive = require('react-responsive');

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _DateFormatConverter = require('../DateFormatConverter.js');

var _LevelSettings = require('./LevelSettings');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _LogTable = require('./LogTable.less');

var _LogTable2 = _interopRequireDefault(_LogTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogTable = exports.LogTable = function (_Component) {
	_inherits(LogTable, _Component);

	function LogTable() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, LogTable);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LogTable.__proto__ || Object.getPrototypeOf(LogTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			showLevelSettings: false,
			highlightedRequest: null
		}, _this.toggleLevelSettings = function () {
			_this.setState({ showLevelSettings: !_this.state.showLevelSettings });
		}, _this.toggleRelativeTime = function () {
			_this.props.setRelative(!_this.props.relative);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(LogTable, [{
		key: 'highlightRequest',
		value: function highlightRequest(highlightedRequest) {
			this.setState({ highlightedRequest: highlightedRequest });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var timeClass = _LogTable2.default.time + (this.props.relative ? ' ' + _LogTable2.default.relative : '');

			var getTimeStamp = function getTimeStamp(entry) {
				var time = new Date(entry.time);
				if (_this2.props.relative) {
					return React.createElement(_reactTime2.default, { value: time, relative: true,
						onClick: _this2.toggleRelativeTime });
				} else {
					return React.createElement(_reactTime2.default, { value: time, onClick: _this2.toggleRelativeTime,
						format: (0, _DateFormatConverter.convertDateFormat)(_this2.props.dateFormat) });
				}
			};
			var getTimeTitle = function getTimeTitle(entry) {
				var time = new Date(entry.time);
				if (_this2.props.relative) {
					return (0, _moment2.default)(time).format((0, _DateFormatConverter.convertDateFormat)(_this2.props.dateFormat));
				} else {
					return (0, _moment2.default)(time).fromNow();
				}
			};
			var rows = this.props.entries.map(function (entry, i) {
				var className = _LogTable2.default['level_' + entry.level];
				if (entry.reqId === _this2.state.highlightedRequest) {
					className += ' ' + _LogTable2.default.highlight;
				}
				return React.createElement(
					'tr',
					{ className: className, key: i,
						onClick: _this2.highlightRequest.bind(_this2, entry.reqId) },
					React.createElement(
						'td',
						{ className: _LogTable2.default.level },
						React.createElement(_LogLevel.LogLevel, { level: entry.level })
					),
					React.createElement(
						'td',
						{ className: _LogTable2.default.app },
						entry.app
					),
					React.createElement(
						'td',
						{ className: _LogTable2.default.message },
						React.createElement(_LogEntry.LogEntry, {
							message: entry.message })
					),
					React.createElement(
						'td',
						{ className: timeClass,
							title: getTimeTitle(entry) },
						getTimeStamp(entry)
					)
				);
			});

			var smallRows = this.props.entries.map(function (entry, i) {
				return React.createElement(
					'div',
					{ className: _LogTable2.default['level_' + entry.level] + ' ' + _LogTable2.default.row,
						key: i },
					React.createElement(
						'div',
						{ className: _LogTable2.default.level + ' ' + _LogTable2.default.column },
						React.createElement(_LogLevel.LogLevel, {
							level: entry.level })
					),
					React.createElement(
						'div',
						{
							className: _LogTable2.default.app + ' ' + _LogTable2.default.column },
						entry.app
					),
					React.createElement(
						'div',
						{
							className: timeClass + ' ' + _LogTable2.default.column },
						getTimeStamp(entry)
					),
					React.createElement(
						'div',
						{ className: _LogTable2.default.message + ' ' + _LogTable2.default.column },
						React.createElement(_LogEntry.LogEntry, {
							message: entry.message })
					)
				);
			});

			if (rows.length === 0) {
				rows = React.createElement(
					'tr',
					{ className: _LogTable2.default.empty },
					React.createElement(
						'td',
						{ colSpan: '4' },
						React.createElement(
							'div',
							{ className: 'emptycontent' },
							React.createElement('div', { className: 'icon-filetype-text' }),
							React.createElement(
								'h2',
								null,
								t('logreader', 'No server logs')
							),
							React.createElement(
								'p',
								null,
								this.props.hidden > 0 ? t('logreader', 'One or more entries are hidden by the log level filter') : t('logreader', 'Everything is working fine')
							)
						)
					)
				);
			}

			var levelSettingsHeader = React.createElement(
				'span',
				{ onClick: this.toggleLevelSettings },
				'Level',
				React.createElement('span', { className: _LogTable2.default['log-settings-toggle'] + ' icon-more' })
			);
			var levelHeader = this.props.inlineSettings ? levelSettingsHeader : "Level";

			return React.createElement(
				'div',
				null,
				React.createElement(
					_reactResponsive2.default,
					{ minWidth: 750 },
					React.createElement(
						'table',
						{ className: _LogTable2.default.logs },
						React.createElement(
							'thead',
							null,
							React.createElement(
								'tr',
								null,
								React.createElement(
									'th',
									{ className: _LogTable2.default.level + ' ' + (this.state.showLevelSettings ? _LogTable2.default.active : '') },
									levelHeader,
									this.state.showLevelSettings ? React.createElement(_LevelSettings.LevelSettings, {
										setLevel: this.props.setLevel,
										levels: this.props.levels
									}) : React.createElement('div', { className: 'hidden' })
								),
								React.createElement(
									'th',
									{ className: _LogTable2.default.app },
									'App'
								),
								React.createElement(
									'th',
									{ className: _LogTable2.default.message },
									'Message'
								),
								React.createElement(
									'th',
									{ className: timeClass,
										onClick: this.toggleRelativeTime },
									'Time'
								)
							)
						),
						React.createElement(
							'tbody',
							null,
							rows
						)
					)
				),
				React.createElement(
					_reactResponsive2.default,
					{ maxWidth: 768 },
					React.createElement(
						'div',
						{ className: _LogTable2.default.smallHeader },
						levelHeader,
						this.state.showLevelSettings ? React.createElement(_LevelSettings.LevelSettings, {
							setLevel: this.props.setLevel,
							levels: this.props.levels
						}) : React.createElement('div', { className: 'hidden' })
					),
					React.createElement(
						'div',
						{ className: _LogTable2.default.logs },
						smallRows
					)
				)
			);
		}
	}]);

	return LogTable;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/Components/LogTable.js
// module id = 646
// module chunks = 0